import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import WhitePlus from '../../../../images/white_plus.svg';
import RedPlus from '../../../../images/red-plus-sign.svg';

export const SectionContainer = styled.div`
  order: 1;
  display: flex;
  flex-direction: column;
  gap: 3.5rem;
  align-items: center;
  position: relative;

  &.pcma {
    > div {
      &:not(:last-child) {
        &:after {
          content: '';
          background-image: url(${WhitePlus});
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          position: absolute;
          height: 2.5rem;
          width: 2.5rem;
          // right side of flex box by half the size of the icon
          right: calc(50% - 1.25rem);
          // top side of flex box by half the row gap and half the size of the icon
          top: calc(100% + 1.75rem - 1.25rem);

          @media only screen and (min-width: ${({ theme }) =>
              theme.breakpoints.md}) {
            right: calc(0% - 1.75rem - 1.25rem);
            // middle of the flex box by half the size of the icon
            top: calc(50% - 1.25rem);
          }
        }
      }
    }
  }

  &.pco {
    > div {
      &:not(:last-child) {
        &:after {
          content: '';
          background-image: url(${RedPlus});
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          position: absolute;
          height: 2.5rem;
          width: 2.5rem;
          // right side of flex box by half the size of the icon
          right: calc(50% - 1.25rem);
          // top side of flex box by half the row gap and half the size of the icon
          top: calc(100% + 1.75rem - 1.25rem);

          @media only screen and (min-width: ${({ theme }) =>
              theme.breakpoints.md}) {
            right: calc(0% - 1.75rem - 1.25rem);
            // middle of the flex box by half the size of the icon
            top: calc(50% - 1.25rem);
          }
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: normal;
    max-width: ${props => (props.columnCount === '2' ? '1024px' : 'unset')};
  }
`;
